import { commentItems } from '@/mocks/home';

export default function SectionComments() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              影迷反馈
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {commentItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className={`${item.avatar} text-primary-600 text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                    <div className="text-xs text-foreground-400">{item.time}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {item.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.likes} 人觉得有用</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}